// extracted by mini-css-extract-plugin
export var numpadContainer = "_qy-1";
export var phoneButton = "_qy-0";